export const setQuoteSubmitted = (quoteId: string) => {
  if (!quoteId || quoteId.length == 0) return;
  localStorage.setItem(`quoteSubmitted-${quoteId}`, quoteId);
};

export const getQuoteHasBeenSubmitted = (quoteId: string) => {
  if (!quoteId) return;
  return localStorage.getItem(`quoteSubmitted-${quoteId}`);
};
